<template>
    <el-container>
        <el-header><fhHeader  @changeNev="changeNev"/></el-header>
        <el-container>
            <el-aside width="250px" class="aside-left"> 
                <AsideLeft @selectMenu="setNavTitle"/>
            </el-aside>
            
            <el-main>
                <div v-if="!loading">
                    <el-breadcrumb separator="/" class="fh-breadcrumb" v-if="path !== 'home'">
                        <el-breadcrumb-item v-for="title in navTitleList" :key="title">{{title}}</el-breadcrumb-item>
                    </el-breadcrumb>
                    <Home v-if="path === 'home'"/>
                    <Centre v-else  :path="path" :isShowBridge="isShowBridge" :componentName="componentName"/>
                </div>
                <fhFooter/>
            </el-main>
        </el-container>
    </el-container>

</template>

<script>
import fhHeader from './headerLeft'
import fhFooter from './footer'
import AsideLeft from './asideLeft'
import Centre from './centre'
import Home from '@/views/home/home'
import FhMenu from "@/fhMenu";
import devConfig from "@/devConfig";
export default {
    data() {
        return {
            navTitleList: [],
            menuData: {},
            path:'home',
            componentName:'home',
            isShowBridge:true,
            loading:false
        }
    },
    components: {
        fhHeader,
        fhFooter,
        AsideLeft,
        Home,
        Centre
    },
    created() {
        const backPath =  cookie.getItem('path') || '0'
        this.loading = true
        devConfig.init(this, () => {
            this.menuData = FhMenu.getMenu()
            if(backPath === '0')
            {
                this.navTitleList.push(this.menuData[0].name)
                this.path = this.menuData[0].url
                this.componentName = this.menuData[0].componentName
            }
            else
            {
                this.setNavTitle(backPath)
            }
            this.loading = false
            
        })
    },

    methods:{
        changeNev(index,index1){
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        },
        setNavTitle(path){
            this.navTitleList = []
            const menuIndex = path.split('-')
            let firMenu = null , secMenu = null ,thrMenu = null
            firMenu = this.menuData[parseInt(menuIndex[0])]

            this.$router.push(firMenu.url)
            if(menuIndex.length > 1)
                secMenu =  this.menuData[parseInt(menuIndex[0])].twoMenu[parseInt(menuIndex[1])]
            if(menuIndex.length > 2)
                thrMenu = this.menuData[parseInt(menuIndex[0])]
                          .twoMenu[parseInt(menuIndex[1])]
                          .thrMenu[parseInt(menuIndex[2])]

            if(firMenu) 
            {
                this.navTitleList.push(firMenu.name)
                this.path = firMenu.url
                if(firMenu.componentName)
                    this.componentName = firMenu.componentName
                    
            }
            

            if(secMenu)
            {
                this.navTitleList.push(secMenu.name)
                if(secMenu.componentName)
                    this.componentName = secMenu.componentName

                if(typeof secMenu.isShowBridge != "undefined")
                    this.isShowBridge = secMenu.isShowBridge
                else
                    this.isShowBridge = true
            }
                
            if(thrMenu)
            {
                this.navTitleList.push(thrMenu.name)
                this.componentName = thrMenu.componentName
                if(typeof thrMenu.isShowBridge != "undefined")
                    this.isShowBridge = thrMenu.isShowBridge
                else
                    this.isShowBridge = true
            }

                
        }
    }
}
</script>


<style src="@/assets/style/fh_form.css" ></style>
<style src="@/assets/style/styles.scss" lang="scss"></style>
<style src="@/assets/style/nav_left.scss" lang="scss"></style>
<style>
.aside-left{
    background-color: #ffffff;
    
}
.fhv-form {
    margin-top: 0;
    min-width: 0;
    width: 600px;
    margin-left: calc(40% - 300px);
}
.fhv-centent{
    margin: 0;
}
.fh-breadcrumb{
    margin: 0 0 20px 0;
    font-size: 16px!important;
}

@media (max-width: 768px){
    .aside-left{
        display: none;
    }
}
@media (max-width: 1065px){
    .fhv-form {
        width: 100%;
        margin-left: 0;
    }
}
</style>

